import { FileText, LayoutList, User } from 'lucide-react';
import type { PathResolver } from '@/components/layout/workspace/types';
import type { RightPanelItem } from '@/components/layout/workspace/rightPanelContext';

export const HOME = '/design/workspace';
export const OWNERS = ['Анна Смирнова', 'Михаил Орлов', 'Елена Петрова'];
export const RECORDS = Array.from({ length: 96 }, (_, i) => ({
  id: String(i + 1).padStart(3, '0'),
  title: ['Продление лицензии', 'Подготовка договора', 'Проверка документов', 'Плановое обслуживание'][i % 4],
  owner: OWNERS[i % 3],
  note: 'Проверить сведения, согласовать условия и зафиксировать результат.',
  amount: (i % 7 === 0 ? -1 : 1) * (125000 + i * 14500),
  currency: (i % 5 === 0 ? 'USD' : 'RUB') as 'USD' | 'RUB',
  deadline: new Date(Date.UTC(2026, 9, 20 + (i % 12), 15, 0)).toISOString(),
  status: (['new', 'review', 'paid'] as const)[i % 3],
}));
export type SampleRecord = (typeof RECORDS)[number];
export const SAMPLE_NOW = Date.UTC(2026, 9, 23, 10);
export const STATUS_OPTIONS = [
  { value: 'new', label: 'Новая', tone: 'info' },
  { value: 'review', label: 'На согласовании', tone: 'warn' },
  { value: 'paid', label: 'Оплачено', tone: 'success' },
] as const;

export function panelOf(record: SampleRecord): RightPanelItem {
  return {
    id: record.id,
    title: record.title,
    path: `${HOME}/record/${record.id}`,
    eyebrow: `Запись № ${record.id}`,
  };
}

export const resolveSample: PathResolver = (path) => {
  const record = RECORDS.find((r) => path === `${HOME}/record/${r.id}`);
  if (record)
    return {
      type: 'object',
      serviceId: 'patterns',
      title: `№ ${record.id} · ${record.title}`,
      icon: FileText,
      homeView: HOME,
    };
  if (path.includes('/person/'))
    return {
      type: 'object',
      serviceId: 'patterns',
      title: OWNERS[Number(path.split('/').at(-1))] ?? 'Сотрудник',
      icon: User,
      homeView: HOME,
    };
  return { type: 'view', serviceId: 'patterns', title: 'Рабочее пространство', icon: LayoutList };
};
